<script lang="ts" setup>
import { computed } from "vue";
import { type RouteLocationRaw, useRoute } from "vue-router";
import { useDisplay } from "vuetify";

import { routeNames } from "#router/constants";
import { appIcons } from "#utilities/icons";

defineProps<{
  /** Whether to show drawer (affects mobile only) */
  showOnMobile: boolean;
}>();

const emit = defineEmits<{
  // eslint-disable-next-line @typescript-eslint/prefer-function-type
  (e: "toggle-drawer"): void;
}>();

interface DrawerNavItem {
  badge?: {
    color?: string;
    label?: string;
    value: string | number | undefined;
  };
  children?: DrawerNavItem[];
  disabled?: boolean;
  exact?: boolean;
  icon: string;
  to: RouteLocationRaw;
  title: string;
}

const drawerNavItems = computed<DrawerNavItem[]>(() => [
  {
    exact: true,
    icon: appIcons.mdiDashboard,
    to: { name: routeNames.dashboard },
    title: "Dashboard",
  },
  {
    icon: appIcons.mdiSongs,
    to: { name: routeNames.song.index },
    title: "Songs",
  },
  {
    icon: appIcons.mdiGroup,
    to: { name: routeNames.group.index },
    title: "Groups",
  },
  { icon: appIcons.mdiList, to: { name: routeNames.list.index }, title: "Lists" },
]);

const { mobile } = useDisplay();
const route = useRoute();

const hideDrawer = computed(() => route.path.includes("logout"));
</script>

<template>
  <VNavigationDrawer
    v-if="!hideDrawer"
    :model-value="mobile ? showOnMobile : true"
    :permanent="!mobile"
    @update:model-value="emit('toggle-drawer')"
  >
    <VList color="primary" density="compact" nav>
      <VListItem
        v-for="navItem in drawerNavItems"
        :key="navItem.title"
        :disabled="navItem.disabled"
        :exact="navItem.exact"
        :title="navItem.title"
        :to="navItem.to"
      >
        <template #append>
          <VBadge
            v-if="navItem.badge"
            v-tooltip="navItem.badge.label"
            :color="navItem.badge.color"
            :content="navItem.badge.value"
            inline
          />
        </template>
        <template #prepend>
          <VIcon :icon="navItem.icon" />
        </template>
      </VListItem>
    </VList>
  </VNavigationDrawer>
</template>
